import en from './en';

export const defaultLanguage = 'en';
export const appLocales = ['en'];

export default {
  en
};



// WEBPACK FOOTER //
// ./src/lang/index.js